// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3BoUL","fileBtn":"File_fileBtn__1vEmN","closeBtn":"File_closeBtn__2zu-d","fileSelected":"File_fileSelected__3Gt32","disabled":"File_disabled__30nVo"};